var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStride(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "0 0 67 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.1534C0 10.3662 10.3661 0 23.1534 0L65.818 0C65.818 12.7873 55.4518 23.1534 42.6645 23.1534L0 23.1534Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00823975 30.0947L51.9342 30.0947C59.6065 30.0947 65.8262 36.3144 65.8262 43.9868L13.9003 43.9868C6.22793 43.9868 0.00823975 37.7671 0.00823975 30.0947Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 74.0911C0 61.3038 10.3662 50.9376 23.1534 50.9376L66.2568 50.9376C66.2568 63.7249 55.8906 74.0911 43.1033 74.0911H0Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStride);
export default __webpack_public_path__ + "static/media/stride.f19d6d670a565b75a18dfb24c35743c3.svg";
export { ForwardRef as ReactComponent };